import { find } from "lodash";
import React from "react";
import { Badge, ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import { OrderCostingVersion, TApiOrderDetails } from "../../../../api/endpoints/Order";

interface Props {
  order: TApiOrderDetails;
  availableVersions: Array<OrderCostingVersion>;
  onVersionSelect: (version: OrderCostingVersion['version']) => void;
}

const ChangeCostingVersionButton = (props: Props) => {
  const { order, availableVersions, onVersionSelect } = props;
  const currentVersion = order.cost.version;

  const currentVersionTitle = find(availableVersions, { version: currentVersion })?.title;

  return (
    <div className="change-costing-version-button">
      <span className="label">
        Select costing version:
      </span>
      <DropdownButton
        as={ButtonGroup}
        className="dropdown-button"
        title={currentVersionTitle}
        id="costing-version-select"
        size="sm"
      >
        {
          availableVersions.map((costingVersion) => (
            <Dropdown.Item
              key={costingVersion.version}
              eventKey={costingVersion.version}
              onClick={() => onVersionSelect(costingVersion.version)}
              disabled={costingVersion.version === currentVersion}
            >
              <div className="dropdown-item-content">
                <div className="title-wrapper">
                <span className="title">
                  {costingVersion.title}
                </span>

                  {
                    costingVersion.version === currentVersion &&
                    <Badge pill variant="info">current</Badge>
                  }
                </div>

                <div className="description">
                  {costingVersion.description}
                </div>
              </div>
            </Dropdown.Item>
          ))
        }
      </DropdownButton>
    </div>
  );
}

export default ChangeCostingVersionButton;
